import React from 'react';

import { SpriteProps } from './sprite-types';

import Sprite from './sprite';

import styles from './sprite-social.module.scss';

// Look styles file to find the valid sprites
function LocalSprite(props: SpriteProps) {
    return <Sprite context='SOCIAL' styles={styles} {...props} />;
}

export function SpriteSocialWhite(props: SpriteProps) {
    return <LocalSprite {...props} />;
}

export function SpriteSocialCyan(props: SpriteProps) {
    return <LocalSprite {...props} sheetIndexUnhovered={1} />;
}

export function SpriteSocialBlue(props: SpriteProps) {
    return <LocalSprite {...props} sheetIndexUnhovered={2} sheetIndexHovered={1} />;
}

export function SpriteSocialGrey(props: SpriteProps) {
    return <LocalSprite {...props} sheetIndexUnhovered={3} sheetIndexHovered={1} />;
}

export function SpriteSocialInk(props: SpriteProps) {
    return <LocalSprite {...props} sheetIndexUnhovered={4} sheetIndexHovered={1} />;
}
